import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import { ConversationEventGroups } from 'components/conversation/conversationEventGroups';
import { useReadPatchedConversation } from 'utils/conversation/useReadPatchedConversation';
import { useAppPathParams } from 'utils/url/useAppPathParams';
import styles from './conversationMessages.module.scss';
/** Represents the messages section of the conversation main view. */
export const ConversationMessages = () => {
    const { csid } = useAppPathParams('/conversation/:csid');
    const [readConversations, { data, asyncStatus }] = useReadPatchedConversation();
    // Handles reading the conversation.
    useEffect(() => {
        readConversations({ csid: parseInt(csid) });
    }, [csid, readConversations]);
    return (_jsx(_Fragment, { children: asyncStatus === 'fulfilled' && data && (_jsx(ConversationEventGroups, { className: styles.root, mainConversation: data.data.history.main_conversation, groupsConfig: [
                'group:contact_form',
                'group:email',
                'group:facebook_messenger',
                'group:instagram_story',
                'group:messenger',
                'group:pstn_phone',
                'group:sms',
                'group:twitter',
                'group:voicemail',
                'group:whats_app',
                'group:widget_chat',
                'group:conversation:wrapup_message',
            ] })) }));
};
